<ng-container *transloco="let t">
  <div class="ophthalmology-report" [formGroup]="form">
    <h3 class="section-title">{{ t('ophthalmology.historyTitle') }}</h3>
    <mat-form-field appearance="outline" class="w-full mb-3">
      <textarea matInput formControlName="history" rows="2"></textarea>
    </mat-form-field>

    <!-- Eye columns header -->
    <div class="eye-columns-header">
      <span class="eye-col-title">{{ t('ophthalmology.leftEye') }}</span>
      <span class="eye-col-title">{{ t('ophthalmology.rightEye') }}</span>
    </div>

    <!-- Diagnosis -->
    <h3 class="section-title">{{ t('ophthalmology.diagnosisTitle') }}</h3>
    <div class="eye-columns">
      <div class="eye-col">
        <div class="eye-field">
          <span class="field-label">{{ t('ophthalmology.eyelids') }}</span>
          <mat-form-field appearance="outline" class="w-full">
            <textarea
              matInput
              formControlName="diagnosis_eyelids_left"
              rows="2"
            ></textarea>
          </mat-form-field>
        </div>
        <div class="eye-field">
          <span class="field-label">{{
            t('ophthalmology.anterior_chamber')
          }}</span>
          <mat-form-field appearance="outline" class="w-full">
            <textarea
              matInput
              formControlName="diagnosis_anterior_chamber_left"
              rows="2"
            ></textarea>
          </mat-form-field>
        </div>
        <div class="eye-field">
          <span class="field-label">{{ t('ophthalmology.lens') }}</span>
          <mat-form-field appearance="outline" class="w-full">
            <textarea
              matInput
              formControlName="diagnosis_lens_left"
              rows="2"
            ></textarea>
          </mat-form-field>
        </div>
        <div class="eye-field">
          <span class="field-label">{{ t('ophthalmology.vitreous') }}</span>
          <mat-form-field appearance="outline" class="w-full">
            <textarea
              matInput
              formControlName="diagnosis_vitreous_left"
              rows="2"
            ></textarea>
          </mat-form-field>
        </div>
        <div class="eye-field">
          <span class="field-label">{{ t('ophthalmology.iris_pupil') }}</span>
          <mat-form-field appearance="outline" class="w-full">
            <textarea
              matInput
              formControlName="diagnosis_iris_left"
              rows="2"
            ></textarea>
          </mat-form-field>
        </div>
      </div>
      <div class="eye-col">
        <div class="eye-field">
          <span class="field-label">{{ t('ophthalmology.eyelids') }}</span>
          <mat-form-field appearance="outline" class="w-full">
            <textarea
              matInput
              formControlName="diagnosis_eyelids_right"
              rows="2"
            ></textarea>
          </mat-form-field>
        </div>
        <div class="eye-field">
          <span class="field-label">{{
            t('ophthalmology.anterior_chamber')
          }}</span>
          <mat-form-field appearance="outline" class="w-full">
            <textarea
              matInput
              formControlName="diagnosis_anterior_chamber_right"
              rows="2"
            ></textarea>
          </mat-form-field>
        </div>
        <div class="eye-field">
          <span class="field-label">{{ t('ophthalmology.lens') }}</span>
          <mat-form-field appearance="outline" class="w-full">
            <textarea
              matInput
              formControlName="diagnosis_lens_right"
              rows="2"
            ></textarea>
          </mat-form-field>
        </div>
        <div class="eye-field">
          <span class="field-label">{{ t('ophthalmology.vitreous') }}</span>
          <mat-form-field appearance="outline" class="w-full">
            <textarea
              matInput
              formControlName="diagnosis_vitreous_right"
              rows="2"
            ></textarea>
          </mat-form-field>
        </div>
        <div class="eye-field">
          <span class="field-label">{{ t('ophthalmology.iris_pupil') }}</span>
          <mat-form-field appearance="outline" class="w-full">
            <textarea
              matInput
              formControlName="diagnosis_iris_right"
              rows="2"
            ></textarea>
          </mat-form-field>
        </div>
      </div>
    </div>

    <!-- Findings -->
    <h3 class="section-title">{{ t('ophthalmology.findingsTitle') }}</h3>
    <div class="eye-columns">
      <div class="eye-col">
        @for (row of findingsRows; track row.k) {
          <div class="eye-field">
            <span class="field-label">{{ t(row.key) }}</span>
            <mat-form-field appearance="outline" class="w-full">
              <textarea
                matInput
                [formControlName]="'findings_' + row.k + '_left'"
                rows="2"
              ></textarea>
            </mat-form-field>
          </div>
        }
      </div>
      <div class="eye-col">
        @for (row of findingsRows; track row.k) {
          <div class="eye-field">
            <span class="field-label">{{ t(row.key) }}</span>
            <mat-form-field appearance="outline" class="w-full">
              <textarea
                matInput
                [formControlName]="'findings_' + row.k + '_right'"
                rows="2"
              ></textarea>
            </mat-form-field>
          </div>
        }
      </div>
    </div>

    <!-- Full-width tail fields -->
    <h3 class="section-title">{{ t('ophthalmology.planTitle') }}</h3>
    <mat-form-field appearance="outline" class="w-full mb-3">
      <textarea
        matInput
        formControlName="planRecommendations"
        rows="2"
      ></textarea>
    </mat-form-field>

    <h3 class="section-title">
      {{ t('ophthalmology.ocularMedicationsTitle') }}
    </h3>
    <mat-form-field appearance="outline" class="w-full mb-3">
      <textarea
        matInput
        formControlName="ocularMedications"
        rows="2"
      ></textarea>
    </mat-form-field>

    <h3 class="section-title">
      {{ t('ophthalmology.systemicMedicationsTitle') }}
    </h3>
    <mat-form-field appearance="outline" class="w-full mb-3">
      <textarea
        matInput
        formControlName="systemicMedications"
        rows="2"
      ></textarea>
    </mat-form-field>

    <h3 class="section-title">{{ t('ophthalmology.noteTitle') }}</h3>
    <mat-form-field appearance="outline" class="w-full mb-3">
      <textarea matInput formControlName="note" rows="2"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput formControlName="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </div>
</ng-container>
